import { Plus } from 'lucide-react';
import Sidebar from './Sidebar';
import NoteEditor from './NoteEditor';
import { Button } from './ui/button';
import { useNotes } from '../notion/useNotes';
import { useAuth } from '../auth/AuthContext';

export default function Workspace() {
  const { token } = useAuth();
  const {
    notes,
    activeId,
    activeNote,
    loading,
    setActiveId,
    createNote,
    deleteNote,
    setTitle,
    updateDocument,
  } = useNotes(token);

  return (
    <div className="flex h-screen w-full">
      <Sidebar
        notes={notes}
        activeId={activeId}
        onSelect={setActiveId}
        onCreate={() => createNote()}
        onDelete={deleteNote}
      />
      <main className="flex-1 overflow-y-auto bg-background">
        {loading ? (
          <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
            Loading notes...
          </div>
        ) : activeNote ? (
          <NoteEditor
            key={activeNote.id}
            note={activeNote}
            updateDocument={updateDocument}
            setTitle={setTitle}
          />
        ) : (
          <div className="flex h-full flex-col items-center justify-center gap-4 text-muted-foreground">
            <Button onClick={() => createNote()}>
              <Plus className="h-4 w-4" /> New note
            </Button>
            <p className="text-sm">Your notes will appear here.</p>
          </div>
        )}
      </main>
    </div>
  );
}
